import React, { Component } from "react";
import Lottie from "react-lottie-player";
import styled, { css } from "styled-components";
import fixedBlur from "./Fixed Blur.json";

import { app } from "js/namespaces";
import { getStaticUrl } from "js/config";

const Container = styled.div`
    width: 100%;
    height: 100%;
    opacity: ${props => props.opacity};
    transition: opacity 1500ms;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
    overflow: hidden;

    ${props => props.absolutePosition && css`
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
    `}
    
    img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
`;

const Label = styled.h2`
    z-index: 0;
    margin: 0;
    color: white !important;
    font-size: ${props => props.$fontSize}px;
    font-weight: 600;
    line-height: 1.1;
    text-align: center;
    text-shadow: rgba(0, 0, 0, 0.2) 0px 1px 0px;
`;

const LabelPill = styled(Label)`
    padding: 0.45em 1em;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.7);
`;

export class AiGenerateProgress extends Component {
    render() {
        const { fontSize = 40, label = null, opacity = 1, absolutePosition = false, showLabelPill = false } = this.props;
        const labelFontSize = Math.max(16, Math.round(fontSize * 0.82));
        const LabelComponent = showLabelPill ? LabelPill : Label;

        return (
            <Container opacity={opacity} absolutePosition={absolutePosition}>
                {app.isMobileOrTablet && (
                    <img src={getStaticUrl("/images/ai-gen.jpg")} />
                )}
                {!app.isMobileOrTablet && <Lottie loop animationData={fixedBlur} play
                                                  style={{
                                                      width: "300%",
                                                      height: "300%",
                                                      position: "absolute",
                                                      zIndex: 0,
                                                      opacity: 1,
                                                      transition: "opacity 500ms"
                                                  }}
                />}
                {label?.length && <LabelComponent $fontSize={labelFontSize}>{label}</LabelComponent>}
            </Container>
        );
    }
}
